// extracted by mini-css-extract-plugin
export default {"template-modals":"Modals_template-modals__Lp4yH","template-modals__footer":"Modals_template-modals__footer__y2rNf"};